module.exports = __webpack_public_path__ + "img/info.002.97d544f1.jpeg";